import { useParams, useSearchParams } from "react-router-dom"
import { SmartIDLoading } from "../components/login/SmartIDLoading"
import { useEffect, useState } from "react";

export const SmartIdVerificationPage = () => {

    const [verificationCode, setVerificationCode] = useState("");

    const [search, setSearch] = useSearchParams();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        if (search.get("code")) {
            setVerificationCode(search.get("code")!);
        }
    }, [search])

    return (
        <div className="w-full h-full flex justify-center items-center ">
            <SmartIDLoading code={verificationCode} type={"VERIFICATION"}/>
        </div>
    )
}